var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoreExpand',{attrs:{"title":_vm.fixflowHeading}},[_c('iframe',{staticStyle:{"border":"0px","width":"100%","height":"700px","overflow":"hidden"},attrs:{"scrollbars":"no","src":"https://claydonhomes.fixflo.com/issue/plugin"}})])}
var staticRenderFns = []

export { render, staticRenderFns }